import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueTippy from 'vue-tippy'
import router from '@/router'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import VueAwesomePaginate from 'vue-awesome-paginate'
import gettext from '@/gettext'
import { getCookie } from './helpers/cookie'
import App from './App.vue'

import './theme/style.scss'
import 'tippy.js/dist/tippy.css'

dayjs.extend(customParseFormat)

const pinia = createPinia()

const DASHBOARD_URL = process.env.VUE_APP_DASHBOARD_URL || 'https://dashboard.dittomusic.com'
const JWT_TOKEN = process.env.VUE_APP_JWT_TOKEN
const JWT = getCookie(`DittoMusic[${JWT_TOKEN}Customer]`) || getCookie(`DittoMusic[${JWT_TOKEN}]`)

if (!JWT || !JWT.length) {
  window.location.replace(`${DASHBOARD_URL}/login`)
} else {
  createApp(App)
    .use(router)
    .use(pinia)
    .use(VueTippy, {
      defaultProps: {
        arrow: true,
        maxWidth: 240,
        interactive: true,
        theme: 'tippy-tooltip',
      },
    })
    .use(VueAwesomePaginate)
    .use(gettext)
    .mount('#app')
}
